import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI, LABELINGCHIMP_SAM_API } from '../../../API';
import axios from 'axios';
import { logFrontendActivity } from '../../General/activityLogger';

/* canceling previous requests if multiple requests is triggered */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const manifestsslice = createSlice({
    name: 'manifests',
    initialState: {
        data: [],
        message: [],
        meta: {
            shippingchimp_manifest_number: "",
            manifestStatus: "",
            date: "",
            manifestNumber: "",
            sorting: JSON.stringify([{
                field: 'created_at',
                sort: 'desc',
              }]),
            page: 1,
            per_page: 10
        },
        loading: false,
        notification: { show: false, messageContent: "", messageType: "success" },
        manifestClose: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        }
    },
    reducers: {
        getManifest: (state) => {
            return {
                ...state,
                data: [],
                loading: true
            }
        },
        getManifestSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                meta: action && action.payload && action.payload.data && action.payload.data.meta,
                un_closed_shipments_count: action && action.payload && action.payload.data && action.payload.data.un_closed_shipments_count,
                manifest_all_in_progress: action && action.payload && action.payload.data && action.payload.data.manifest_all_in_progress,
                loading: false
            }
        },
        getManifestFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
            }
        },
        postTrackingNumberCloseManifest: (state, action) => {
            return {
                ...state,
                manifestClose: {
                    ...state.manifestClose,
                    loading: true
                }
            }
        },
        postTrackingNumberCloseManifestSuccess: (state, action) => {
            return {
                ...state,
                 notification: { show: true, messageContent: (action.payload && action.payload.data && action.payload.data.desc && action.payload.data.desc === "success") ? ["Manifest close triggered successfully"] : [""], messageType: "success" },
            }
        },
        postTrackingNumberCloseManifestFailure: (state, action) => {
            // 1. Robust status detection for 500 errors
            const status = action?.payload?.status || action?.status;
            const payloadData = action?.payload?.data;

            // 2. Determine the error message as an array
            let errorArray = [];

            if (status === 500 || !action?.payload) {
                // Handle server crashes or missing payloads
                errorArray = ["Internal Server Error. Unable to close manifest at this time."];
            } else {
                // Handle standard API errors (422, etc.)
                const msg = payloadData?.message || "An unexpected error occurred while closing the manifest.";
                errorArray = [msg];
            }

            return {
                ...state,
                manifestClose: {
                    ...state.manifestClose,
                    loading: false,
                    notification: {
                        show: true,
                        messageContent: errorArray, // strictly an array for UI mapping
                        messageType: "error",
                        status: status || 500 // Store for conditional UI styling
                    },
                }
            };
        },
        // Inside manifestsslice reducers:
        postPickupRequest: (state) => {
            return {
                ...state,
                pickupLoading: true // Track loading for the pickup button
            }
        },
        postPickupRequestSuccess: (state, action) => {
            return {
                ...state,
                pickupLoading: false,
                notification: { 
                    show: true, 
                    messageContent: ["Pickup scheduled successfully"], 
                    messageType: "success" 
                }
            }
        },
        postPickupRequestFailure: (state, action) => {
            return {
                ...state,
                pickupLoading: false,
                notification: { 
                    show: true, 
                    messageContent: action.payload?.data?.message || ["Failed to schedule pickup"], 
                    messageType: "error" 
                }
            }
        },
        resetNotification: (state, action) => {
            return {
                ...state,
                notification: { show: false, messageContent: "", messageType: "success" },
                manifestClose: {
                    ...state.manifestClose,
                    notification: { show: false, messageContent: "", messageType: "success" }

            }
        }
        }
    }
})

export const { getManifest, getManifestSuccess, getManifestFailure } = manifestsslice.actions;

export const fetchManifest = (meta) => {

    return (dispatch) => {
        const qs = Object.keys(meta)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
            .join('&');

        dispatch(getManifest());
        try {
            LABELGENAPI
                .get('/manifests?status=CLOSED&' + qs)
                .then(function (response) {
                    dispatch(getManifestSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getManifestFailure(error.response));
                });
        } catch (error) {
            dispatch(getManifestFailure());
        }
    }
};

export const { postTrackingNumberCloseManifest, postTrackingNumberCloseManifestSuccess, postTrackingNumberCloseManifestFailure } = manifestsslice.actions;

export const dopostTrackingNumberCloseManifest = (userid, data, api_token, meta) => {
    return (dispatch) => {
        dispatch(postTrackingNumberCloseManifest());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/close-manifest', data, { headers: { 'x-api-key': api_token, 'Content-Type': 'application/json' } })
                .then(function (response) {
                    dispatch(postTrackingNumberCloseManifestSuccess(response));
                    logFrontendActivity({
                        group: 'MANIFEST_CLOSE',
                        subgroup: 'MANIFEST',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                    try {
                        if (response.data.desc === "success") {
                            dispatch(fetchManifest(meta));
                        }
                    } catch (error) {
                        dispatch(postTrackingNumberCloseManifestFailure(error.response));
                        logFrontendActivity({
                            group: 'MANIFEST_CLOSE',
                            subgroup: 'MANIFEST',
                            action: 'FAILURE',
                            request_data: data,
                            response_data: error.response?.data || {},
                            log_ref: logRef,
                            userid: userid
                        }).then((ref) => {
                            if (ref) {
                                console.log('Activity log recorded with log_ref:', ref);
                            }
                        });
                    }
                })
                .catch(function (error) {
                    dispatch(postTrackingNumberCloseManifestFailure(error.response));
                    logFrontendActivity({
                            group: 'MANIFEST_CLOSE',
                            subgroup: 'MANIFEST',
                            action: 'FAILURE',
                            request_data: data,
                            response_data: error.response?.data || {},
                            log_ref: logRef,
                            userid: userid
                        }).then((ref) => {
                            if (ref) {
                                console.log('Activity log recorded with log_ref:', ref);
                            }
                        });
                });
        } catch (error) {
            dispatch(postTrackingNumberCloseManifestFailure());
            logFrontendActivity({
                group: 'MANIFEST_CLOSE',
                subgroup: 'MANIFEST',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { postPickupRequest, postPickupRequestSuccess, postPickupRequestFailure } = manifestsslice.actions;

export const doRequestManifestPickup = (data, api_token, userid, meta) => {
    return (dispatch) => {
        dispatch(postPickupRequest());
        const logRef = crypto.randomUUID();

        try {
            // Using LABELINGCHIMP_SAM_API as per your close-manifest logic
            LABELGENAPI
                .post('/manifests/request-pickup', data, { 
                    headers: { 
                        'x-api-key': api_token, 
                        'Content-Type': 'application/json' 
                    } 
                })
                .then(function (response) {
                    dispatch(postPickupRequestSuccess(response));
                    dispatch(fetchManifest(meta));
                    // Log Activity
                    logFrontendActivity({
                        group: 'MANIFEST_PICKUP',
                        subgroup: 'MANIFEST',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    });
                })
                .catch(function (error) {
                    dispatch(postPickupRequestFailure(error.response));
                    
                    // Log Failure
                    logFrontendActivity({
                        group: 'MANIFEST_PICKUP',
                        subgroup: 'MANIFEST',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    });
                });
        } catch (error) {
            dispatch(postPickupRequestFailure());
        }
    };
};

export const { resetNotification } = manifestsslice.actions;

export const resetGenerateManifestNotification = () => {
    return (dispatch) => {
        dispatch(resetNotification());
    }
}

export default manifestsslice.reducer;
